import http from '../../services/http-common';


// ✅ Add these imports (Syncfusion PDF)
import {
  PdfDocument, PdfPageSize,
  PdfStandardFont, PdfFontFamily, PdfFontStyle,
  PdfGrid, PdfPen, PdfColor, PdfSolidBrush,
  PdfStringFormat, PdfTextAlignment, PdfVerticalAlignment
} from "@syncfusion/ej2-pdf-export";
import { PdfPageOrientation } from "@syncfusion/ej2-pdf-export";

import moment from 'moment';
class InvoiceService {

  getForList(data) {
    let queryParams = new URLSearchParams(data).toString();
    return http.get(`/Invoice/list?${queryParams}`);
  }

  getInvoiceDetail(data) {
        let queryParams = new URLSearchParams(data).toString();

    return http.get(`/Invoice/InvoiceDetail?${queryParams}`);
  }

  getNextInvoiceID(InvoiceType = 'SS') {
    return http.get(`/Invoice/NextInvoiceID?InvoiceType=${InvoiceType}`);
  }

  // Dropdown sources (optional)
  getBuyerDDSource() {
    return http.get(`/Invoice/BuyerDDSource`);
  }
  getHSCodeDDSource() {
    return http.get(`/Invoice/HSCodeDDSource`);
  }
  getUnitOfMeasurementDDSource() {
    return http.get(`/Invoice/UnitOfMeasurementDDSource`);
  }

  addRecords(data) {
    return http.post(`/Invoice/add`, data);
  }

  updateMainData(data) {
    return http.put(`/Invoice/update`, data);
  }

  updateDetailData(data) {
    return http.put(`/Invoice/update-detail`, data);
  }
// =========================
// REPORT (Preview / PDF)
// =========================

toNum(v) {
  const n = parseFloat(String(v ?? "0").replace(/,/g, ""));
  return isNaN(n) ? 0 : n;
}
async generateInvoiceReportPDF(mainRow, detailRows) {
  const doc = new PdfDocument();
  doc.pageSettings.size = PdfPageSize.a4;
  doc.pageSettings.orientation = PdfPageOrientation.Portrait;
  doc.pageSettings.margins.all = 8;

  const page = doc.pages.add();
  const g = page.graphics;

  const black = new PdfSolidBrush(new PdfColor(0, 0, 0));
  const linePen = new PdfPen(new PdfColor(0, 0, 0), 1);
  const outerPen = new PdfPen(new PdfColor(0, 0, 0), 1.2);

  const fontTitle = new PdfStandardFont(PdfFontFamily.Helvetica, 14, PdfFontStyle.Bold);
  const fontBold = new PdfStandardFont(PdfFontFamily.Helvetica, 7, PdfFontStyle.Bold);
  const font = new PdfStandardFont(PdfFontFamily.Helvetica, 7);

  const pageW = page.getClientSize().width;

  const x0 = 8;
  const xR = pageW - 8;
  const usableW = xR - x0;

  const txt = (v) => {
    const s = String(v ?? "").trim();
    return s ? s : "";
  };

  const toNum = (v) => {
    const n = parseFloat(String(v ?? "0").replace(/,/g, ""));
    return isNaN(n) ? 0 : n;
  };

  // ✅ EXACT underline start after ":" using measureString
  const textW = (fnt, s) => {
    try {
      return fnt.measureString(String(s)).width || 0;
    } catch {
      return String(s).length * 5; // safe fallback
    }
  };

  const drawField = (caption, value, capX, y, lineEndX) => {
    const capText = `${(caption || '').toUpperCase()} :`;
    g.drawString(capText, fontBold, null, black, capX, y);

    // underline starts immediately after ":"
    const startX = capX + textW(fontBold, capText) + 6;

    g.drawLine(linePen, startX, y + 11, lineEndX, y + 11);
g.drawString(txt(String(value || '').toUpperCase()), font, null, black, startX + 2, y);
  };

  // =========================
  // HEADER (better spacing)
  // =========================
let y = 10;

// ===== Company (Big, Center) =====
const companyName = txt((mainRow?.sellerBusinessName || '').toUpperCase());
const sellerNTN = txt((mainRow?.sellerNTNCNIC || '').toUpperCase());
const sellerAddress = txt((mainRow?.sellerAddress || '').toUpperCase());

// Company Name (center)
const fontCompany = new PdfStandardFont(PdfFontFamily.Helvetica, 18, PdfFontStyle.Bold);
const wCompany = fontCompany.measureString(companyName).width;
g.drawString(companyName, fontCompany, null, black, (pageW - wCompany) / 2, y);
y += 25;

// NTN (center)
const ntnLine = (`NTN: ${sellerNTN}` || '').toUpperCase();
const fontNTN = new PdfStandardFont(PdfFontFamily.Helvetica, 13, PdfFontStyle.Bold);
const wNTN = fontNTN.measureString(ntnLine).width;
g.drawString(ntnLine, fontNTN, null, black, (pageW - wNTN) / 2, y);
y += 22;

// Address (center)
const fontAddress = new PdfStandardFont(PdfFontFamily.Helvetica, 13, PdfFontStyle.Bold);
const wAddr = fontAddress.measureString(sellerAddress).width;  // ✅ FIX: measure with same font
g.drawString(sellerAddress, fontAddress, null, black, (pageW - wAddr) / 2, y);
y += 20;

// Heading (center)
const invoiceTitle = "SALE INVOICE";
const wInv = fontTitle.measureString(invoiceTitle).width;
g.drawString(invoiceTitle, fontTitle, null, black, (pageW - wInv) / 2, y);
y += 30;


  const invoiceNo = txt(mainRow?.InvoiceID);
  const invDate = mainRow?.InvoiceDate
    ? moment(mainRow.InvoiceDate).format("DD-MMM-YYYY")
    : "";

  // Invoice No (left) + Date (right)
  const dateCapX = x0 + Math.floor(usableW * 0.55);
  drawField("Invoice No", invoiceNo, x0, y, x0 + Math.floor(usableW * 0.48));
  drawField("Date", invDate, dateCapX, y, xR);
  y += 25; // ✅ increase main section row gap

  // Buyer
  drawField("Buyer's Name", (mainRow?.buyerBusinessName || mainRow?.BuyerNTNCNIC), x0, y, xR);
  y += 25;

  // Address
  drawField("Address", mainRow?.buyerAddress, x0, y, xR);
  y += 25;
// Phone + Sales Tax + NTN (3 fields, no overlap)
const phoneCapX = x0;
const salesTaxCapX = x0 + Math.floor(usableW * 0.34);
const ntnCapX = x0 + Math.floor(usableW * 0.68);

// Phone ends before Sales Tax starts
drawField("Phone #", mainRow?.buyerContactNumber || mainRow?.buyerContactNumber || mainRow?.buyerContactNumber, phoneCapX, y, salesTaxCapX - 12);

// Sales Tax ends before NTN starts
drawField("Sales Tax Regn #", mainRow?.buyerSTRN, salesTaxCapX, y, ntnCapX - 12);

// NTN ends at right edge
drawField("N.T.N #", mainRow?.BuyerNTNCNIC, ntnCapX, y, xR);

y += 25;

// =========================
// TABLE (Perfect fit to page)
// =========================

// IMPORTANT: client size already respects margins
const clientW = page.getClientSize().width;

// draw table from left edge of client area
const tableX = 0;
const tableW = clientW;          // full usable width
const grid = new PdfGrid();
grid.columns.add(10);

// tighter padding (fix numeric look)
if (!grid.style) grid.style = {};
grid.style.cellPadding = { left: 2, right: 3, top: 3, bottom: 3 };
grid.style.font = font;

// widths: last col = remaining (no overflow)
// const col = (p) => Math.floor(tableW * p);

// const w0 = col(0.10);  // QTY wider
// const w1 = col(0.28);  // DESC
// const w2 = col(0.12);  // UNIT PRICE
// const w3 = col(0.13);  // VALUE
// const w4 = col(0.10);  // TAX RATE
// const w5 = col(0.12);  // TAX AMT
// const w6 = tableW - (w0 + w0 + w0 + w0 +  w1 + w2 + w3 + w4 + w5); // remaining (perfect fit)
const col = (p) => tableW * p; // ❌ NO floor here


const w0 = col(0.10); // x4 = 32%
const w1 = col(0.15); // DESCRIPTION
const w2 = col(0.09); // UNIT PRICE
const w3 = col(0.09); // VALUE
const w4 = col(0.09); // TAX RATE
const w5 = col(0.09); // TAX AMT

// Remaining column (perfect fit, no overflow)
const w6 =
  Math.floor(
    tableW - (w0 * 4 + w1 + w2 + w3 + w4 + w5)
  );


grid.columns.getColumn(0).width = w0;
grid.columns.getColumn(1).width = w0;
grid.columns.getColumn(2).width = w0;
grid.columns.getColumn(3).width = w0;
grid.columns.getColumn(4).width = w1;
grid.columns.getColumn(5).width = w2;
grid.columns.getColumn(6).width = w3;
grid.columns.getColumn(7).width = w4;
grid.columns.getColumn(8).width = w5;
grid.columns.getColumn(9).width = w6;

// Header
const header = grid.headers.add(1)[0];
const headerFmt = new PdfStringFormat(PdfTextAlignment.Center, PdfVerticalAlignment.Middle);

const headers = [
  "QUANTITY",
  "UNIT",
  "FBR QUANTITY",
  "FBR UNIT",
  "DESCRIPTION OF GOODS",
  "UNIT\nPRICE",
  "VALUE OF\nGOODS",
  "RATE OF\nSALES\nTAX",
  "VALUE\nOF SALES\nTAX",
  "TOTAL VALUE"
];

headers.forEach((h, i) => {
  header.cells.getCell(i).value = h;
  header.cells.getCell(i).style.font = fontBold;
  header.cells.getCell(i).style.stringFormat = headerFmt;
});

// DATA
let sumQty = 0, sumValue = 0, sumTax = 0, sumTotal = 0,sumFBRQty=0;

(detailRows || []).forEach((r) => {
  const qty = toNum(r?.Quantity);
  const FBRqty = toNum(r?.FBRQuantity);
  const rate = toNum(r?.Rate);
  const bill = toNum(r?.BillAmount) || (qty * rate);
  const taxPer = toNum(r?.TaxPercent);
  const taxAmt = toNum(r?.TaxAmount) || (bill * (taxPer / 100));
  const total = toNum(r?.TotalAmount) || (bill + taxAmt);

  sumQty += qty;
  sumFBRQty += FBRqty;
  sumValue += bill;
  sumTax += taxAmt;
  sumTotal += total;

  const row = grid.rows.addRow();

  // QTY (right aligned)
  row.cells.getCell(0).value = qty ? qty.toLocaleString("en-US", { maximumFractionDigits: 2 }) : "";
  row.cells.getCell(0).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);
  // QTY (right aligned)
  row.cells.getCell(1).value = r?.UnitOfMeasurement ? r.UnitOfMeasurement : "";
  // row.cells.getCell(0).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);
  row.cells.getCell(1).stringFormat = new PdfStringFormat(PdfTextAlignment.Left, PdfVerticalAlignment.Middle);

  row.cells.getCell(2).value = FBRqty ? FBRqty.toLocaleString("en-US", { maximumFractionDigits: 2 }) : "";
  row.cells.getCell(2).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);
  
  row.cells.getCell(3).value = r?.FBRUnitOfMeasurement ? r.FBRUnitOfMeasurement : "";
  row.cells.getCell(3).stringFormat = new PdfStringFormat(PdfTextAlignment.Left, PdfVerticalAlignment.Middle);

  // DESC (left aligned, small padding feel)
  row.cells.getCell(4).value = txt((r?.ProductDescription || '').toUpperCase());
  row.cells.getCell(4).stringFormat = new PdfStringFormat(PdfTextAlignment.Left, PdfVerticalAlignment.Middle);

  // numeric columns right align
  row.cells.getCell(5).value = rate.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  row.cells.getCell(6).value = bill.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  row.cells.getCell(7).value = taxPer.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  row.cells.getCell(8).value = taxAmt.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  row.cells.getCell(9).value = total.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  [0,2,5,6,7,8,9].forEach((c) => {
    row.cells.getCell(c).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);
  });
});

// TOTAL ROW
const tr = grid.rows.addRow();
tr.cells.getCell(0).value = sumQty ? sumQty.toLocaleString("en-US", { maximumFractionDigits: 2 }) : "";
tr.cells.getCell(1).value = "";
tr.cells.getCell(2).value =sumFBRQty ? sumFBRQty.toLocaleString("en-US", { maximumFractionDigits: 2 }) : "";
tr.cells.getCell(3).value = "";
tr.cells.getCell(4).value = "";
tr.cells.getCell(5).value = "";
tr.cells.getCell(6).value = sumValue.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
tr.cells.getCell(7).value = "";
tr.cells.getCell(8).value = sumTax.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
tr.cells.getCell(9).value = sumTotal.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

for (let i = 0; i < tr.cells.count; i++) {
  tr.cells.getCell(i).style.font = fontBold;
  tr.cells.getCell(i).stringFormat = new PdfStringFormat(PdfTextAlignment.Right, PdfVerticalAlignment.Middle);
}
// Draw grid (fits exactly)
y += 22;
const result = grid.draw(page, { x: tableX, y });

// =========================
// SIGNATURE SECTION (3 blocks)
// =========================
const signY = result.bounds.y + result.bounds.height + 90; // space after table
const lineW = 120;

const signFont = new PdfStandardFont(PdfFontFamily.Helvetica, 9, PdfFontStyle.Regular);
const signPen = new PdfPen(new PdfColor(0, 0, 0), 1);

// positions (left, center, right)
const leftX = tableX + 50;
const centerX = tableX + (tableW / 2) - (lineW / 2);
const rightX = tableX + tableW - lineW - 50;

const drawSign = (label, x) => {
  // line
  g.drawLine(signPen, x, signY, x + lineW, signY);

  // label centered under line
  const w = signFont.measureString(label).width;
  g.drawString(label, signFont, null, black, x + (lineW - w) / 2, signY + 6);
};

drawSign("PREPARED BY", leftX);
drawSign("APPROVED BY", centerX);
drawSign("RECEIVED BY", rightX);


// Single outer border (clean)
g.drawRectangle(outerPen, result.bounds.x, result.bounds.y, result.bounds.width, result.bounds.height);

  // Save
  const file = `INV_${invoiceNo}.pdf`;
  doc.save(file);
  doc.destroy();
  return null;
}

}




export default new InvoiceService();
